/**
 * <img> for the API image shape { alt, width, height, sources: [{ url, width }] }.
 * width/height reserve the box so nothing shifts while the file loads.
 * `priority` marks the LCP image: eager loading and fetchpriority="high".
 * `alt` overrides the image's own alt (pass "" for decorative use).
 */
export default function ResponsiveImage({
  image,
  sizes = '100vw',
  priority = false,
  alt,
  className = '',
  ...rest
}) {
  if (!image || !image.sources || !image.sources.length) return null;
  const sorted = [...image.sources].sort((a, b) => a.width - b.width);
  const srcSet = sorted.map((s) => `${s.url} ${s.width}w`).join(', ');
  const fallback = sorted[Math.min(1, sorted.length - 1)];
  return (
    <img
      src={fallback.url}
      srcSet={srcSet}
      sizes={sizes}
      width={image.width}
      height={image.height}
      alt={alt !== undefined ? alt : image.alt || ''}
      loading={priority ? 'eager' : 'lazy'}
      decoding={priority ? 'sync' : 'async'}
      // React 18 passes unknown lowercase attributes through untouched.
      fetchpriority={priority ? 'high' : undefined}
      className={className}
      {...rest}
    />
  );
}
